import { Autocomplete, TextField, Typography } from '@mui/material';
import { memo, SyntheticEvent, RefObject } from 'react';

interface DistrictOption {
  label: String;
  value: String;
}

interface DistrictProps {
  name?: string;
  disabled?: boolean;
  stateVal?: string;
  errormessage?: string;
  size?: 'small' | 'medium';
  value?: string;
  error?: boolean;
  label?: string;
  required?: boolean;
  onDistrictChange?: (event: SyntheticEvent<Element, Event>, option: DistrictOption | null, name?: string) => void;
  inputRef?: RefObject<HTMLInputElement>;
  list?: DistrictOption[];
}

const District = ({
  name,
  disabled,
  stateVal,
  errormessage,
  size,
  value,
  error,
  label,
  required,
  onDistrictChange,
  inputRef,
  list,
}: DistrictProps) => {
  const Change = (e: SyntheticEvent<Element, Event>, option: DistrictOption | null) => {
    if (onDistrictChange) {
      onDistrictChange(e, option, name);
    }
  };
  console.log(errormessage, 'bbbbbbbbbbb');

  return (
    <>
      <Autocomplete
        id={name}
        size={size}
        disabled={disabled}
        getOptionLabel={(option) => String(option.label)}
        value={list?.find((option) => option?.value.toLowerCase() === value?.toLowerCase()) || null}
        onChange={Change}
        options={list ? list : []}
        renderInput={(params) => (
          <TextField
            required={required}
            error={error}
            inputRef={inputRef}
            sx={{
              '.css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
                borderColor: 'input.border',
              },
              '& input::-ms-reveal, & input::-ms-clear': {
                display: 'none',
              },
              '& input::-webkit-credentials-auto-fill-button': {
                visibility: 'hidden',
                display: 'none !important',
              },
              '.css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root': {
                color: 'input.font',
              },
              '.MuiFormLabel-asterisk': {
                color: 'danger.main',
                fontSize: '20px',
                fontWeight: 'bold',
              },
            }}
            {...params}
            label={label}
          />
        )}
      />
      <Typography
        sx={{
          marginTop: '2px',
          marginLeft: '10px',
          marginBottom: '0px',
          fontSize: '11px',
          color: 'danger.main',
        }}
      >
        {errormessage}
      </Typography>
    </>
  );
};

export default memo(District);
